var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFreight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 322 242",
    enableBackground: "new 0 0 322 242",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M97.5,65.1c1.7-0.7,3.3-1.4,5-2c0.8-0.3,1.6-0.7,2.5-1l2.6-0.8c6.7-2.3,13.8-3.1,20.4-3.6c6.8-0.1,13.1,0.4,19.3,1.6 c6,1.2,11.6,2.9,16.5,5c4.9,2.1,9,4.5,12.4,7c3.4,2.5,6,4.9,8,7.2c2.1,2.3,3.6,4.2,4.6,5.5c0,0,0,0.1,0.1,0.1l-7.9,5.4l21.7,4.1 l4.1-21.7l-7.9,5.4c-0.2-0.3-0.4-0.5-0.7-0.9c-1.2-1.4-3-3.5-5.6-6c-2.5-2.5-5.9-5.5-10.1-8.2c-4.2-2.8-9.2-5.3-14.9-7.4 c-5.7-2.1-11.9-3.7-18.7-4.7c-0.9-0.1-1.7-0.2-2.5-0.3l-1.2-0.2c-0.5-0.1-0.9-0.1-1.4-0.1c-1.8-0.1-3.5-0.2-5.3-0.3 c-0.9,0-1.8-0.1-2.7-0.1c-0.9,0-1.8,0.1-2.7,0.1c-1.8,0.1-3.7,0.2-5.5,0.2c-7.4,0.9-15,2.2-22.2,5l-2.7,1c-0.9,0.3-1.8,0.8-2.7,1.2 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M56,100.3c-0.8,1.6-1.3,3.4-2,5c-0.3,0.8-0.6,1.7-0.9,2.5l-0.5,1.2l-0.3,1.3c-0.4,1.7-0.9,3.4-1.3,5c-0.2,0.8-0.5,1.6-0.6,2.5 c-0.1,0.8-0.3,1.6-0.4,2.4c-0.3,1.6-0.5,3.2-0.8,4.7c-0.3,1.7-0.3,3.2-0.5,4.7c-0.2,3.1-0.2,6.1-0.1,8.9 c0.5,11.5,3.2,20.7,5.6,26.9c1.2,3.1,2.3,5.4,3.1,7c0.8,1.6,1.2,2.4,1.2,2.4s-0.4-0.9-1.1-2.5c-0.7-1.6-1.7-4-2.7-7.1 c-2.1-6.2-4.3-15.5-4.2-26.7c0-2.8,0.2-5.7,0.5-8.7c0.2-1.5,0.4-3.1,0.7-4.5c0.3-1.5,0.7-3.1,1-4.7c0.2-0.8,0.3-1.6,0.5-2.4 c0.2-0.8,0.5-1.5,0.7-2.3c0.5-1.5,1-3.1,1.5-4.7l0.4-1.2l0.5-1.2c0.3-0.8,0.7-1.6,1-2.3c0.7-1.5,1.3-3.2,2.1-4.7 c1.7-3,3.2-6.2,5.4-9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M270.7,87.1c-10.1-1.2-19.8-8.8-23.8-12.3c-1.1-1-2.8-1-4,0c-4.1,3.5-13.8,11.1-23.8,12.3c-1.6,0.2-2.8,1.6-2.7,3.2 c1.2,30.7,21.4,44.1,27.1,47.3c0.9,0.5,2,0.5,3,0c5.7-3.2,25.8-16.6,27.1-47.3C273.5,88.6,272.3,87.3,270.7,87.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 244.9,
    cy: 106,
    r: 14.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 251.6,98.3 242.5,107.4 238.1,102.9 235,106.1 239.4,110.5 242.6,113.7 245.7,110.5 254.8,101.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M198.7,182.9c6.3-0.4,8.3-5.5,8.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M207.3,177.4c0,0,2.7,5.9,9,5.5 c6.3-0.4,8.3-5.5,8.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M224.9,177.4c0,0,2.7,5.9,9,5.5 c6.3-0.4,8.3-5.5,8.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M242.5,177.4c0,0,2.7,5.9,9,5.5 c2.5-0.1,4.4-1,5.6-2.1"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "198.2,157.2 207,157.2 210.3,167.2  235.6,167.2 238.5,157.2 259.5,157.2 253.3,175.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "198.2,154.2 198.2,147.2 228.2,147.2  228.2,164.2  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 221.2,
    y1: 157.2,
    x2: 213.2,
    y2: 157.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 221.2,
    y1: 151.2,
    x2: 217.2,
    y2: 151.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.2,
    y: 141.2,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 3,
    height: 4
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 180.2,
    y1: 197.2,
    x2: 261.2,
    y2: 197.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 58.2,
    y1: 197.2,
    x2: 78.2,
    y2: 197.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 114.2,
    y1: 197.2,
    x2: 151.2,
    y2: 197.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M197.2,162.3v20.5c0,3.8-5.5,8.4-9.3,8.4h-11.7 c-1.6-6-5.4-6.5-9.8-6.5s-8.2,0.5-9.8,6.5h-6.3v-50.6c0-3.5,2.6-7.4,6.2-7.4h12.5c5.7,0,12.3,3.6,15.2,8.5L197.2,162.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M163.3,167.8h-2.7c-0.5,0-0.9-0.4-0.9-0.9v-10.5 c0-0.5,0.4-0.9,0.9-0.9h2.7c0.5,0,0.9,0.4,0.9,0.9v10.5C164.1,167.4,163.8,167.8,163.3,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M150.2,180.2v11h-46.9c-1.6-6-5.4-6.5-9.8-6.5 c-4.4,0-8.2,0.5-9.8,6.5H68.2v-11H150.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 151.4,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 26.5,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 151.4,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 151.4,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 26.5,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 151.4,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.8,
    y: 128.2,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 26.5,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.4,
    y: 128.2,
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 5,
    height: 7.9
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "167.2,133.2 167.2,164.2 195.2,164.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M194.7,179.4h-5c-1.3,0-2.4-1.1-2.4-2.4l0,0 c0-1.3,1.1-2.4,2.4-2.4h5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M92.3,70.5c-4-0.4-8.9-0.5-15,0.1l-5.1-21.4 c-0.1-0.3,0-0.5,0.2-0.7c0.2-0.2,0.4-0.2,0.7-0.2l9.6,2.7c0.2,0.1,0.3,0.2,0.4,0.4L92.3,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M91.6,86.1l-10.8,18.2c-0.1,0.2-0.3,0.3-0.5,0.3 l-9.8,1.8c-0.2,0.1-0.5,0-0.6-0.2c-0.2-0.2-0.2-0.5-0.1-0.7l7-20.9C82.7,85.8,87.6,86.2,91.6,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M50.6,91.8C50.6,91.7,50.6,91.7,50.6,91.8 c-0.2-0.3-0.2-0.5-0.2-0.7l2.8-8.7c1.2-3.7,1.4-7.7,0.5-11.6l-2-8.9c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.4-0.3,0.6-0.2l5.9,0.3 c0.3,0,0.5,0.2,0.6,0.4l4.5,10.9c23.8-4.7,35.3-1.8,40.9,1.5c1.8,1,2.8,2.9,2.7,4.9c-0.1,2-1.2,3.8-3.1,4.6 c-5.8,2.8-17.6,4.6-40.8-2.2l-5.5,10.4c-0.1,0.2-0.4,0.4-0.7,0.4L51.1,92C50.9,92,50.7,91.9,50.6,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#1184A2",
    strokeMiterlimit: 10,
    d: "M96,77.8c-0.1-0.1-0.2-0.3-0.1-0.4l0.1-2.6 c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.1,0.4-0.1c1.4,0.1,3.8,1,3.9,1c0.2,0.1,0.4,0.3,0.4,0.6l-0.1,1.7c0,0.1-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.1L96.4,78C96.2,78,96.1,77.9,96,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#1184A2",
    strokeMiterlimit: 10,
    d: "M95.8,82.4c-0.1-0.1-0.2-0.3-0.1-0.4l0.1-2.6 c0-0.3,0.3-0.6,0.6-0.5l3.8,0.2c0.3,0,0.6,0.3,0.5,0.6l-0.1,1.7c0,0.2-0.2,0.5-0.4,0.5c-0.1,0-2.6,0.7-4,0.7 C96,82.6,95.9,82.6,95.8,82.4C95.8,82.5,95.8,82.4,95.8,82.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M100.5,193.7c0,3.9-3.2,7.1-7.1,7.1 c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1C97.4,186.6,100.5,189.8,100.5,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1184A2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M173.8,193.7c0,3.9-3.2,7.1-7.1,7.1 c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1C170.7,186.6,173.8,189.8,173.8,193.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFreight);
export default __webpack_public_path__ + "static/media/logo-freight.215a86bfa9405a23047c88e6018fd432.svg";
export { ForwardRef as ReactComponent };